"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const iconoir_react_1 = require("iconoir-react");
const Select = (props) => {
    const { label, value, children, onChange, sx = {}, disabled, ...rest } = props;
    return (react_1.default.createElement(material_1.FormControl, { sx: sx, fullWidth: true },
        label && (react_1.default.createElement(material_1.InputLabel, { shrink: true, disabled: disabled }, label)),
        react_1.default.createElement(material_1.Select, { value: value, onChange: onChange, IconComponent: iconoir_react_1.NavArrowDown, disabled: disabled, ...rest }, children)));
};
exports.default = Select;
